import { ArrowRight } from '@liveauctioneers/hammer-ui-core/icons';
import { H3 } from '@liveauctioneers/hammer-ui-core/text';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { addImageParams } from '@/utils/urls';

type CollectionsCardProps = {
    image: string;
    title: string;
    to: string;
};

export const CollectionsCard = ({ image, title, to }: CollectionsCardProps) => {
    const formatMessage = useAppFormatMessage();

    return (
        <RouteLink
            className="group flex w-45 flex-col no-underline hover:no-underline smMin:w-75"
            to={to}
        >
            <div className="relative">
                <div className="relative overflow-hidden rounded-lg border border-surface-200">
                    <img
                        alt={title}
                        className="h-80 w-full object-cover smMin:h-133"
                        loading="lazy"
                        src={addImageParams({ quality: 90, url: image, width: 600 })}
                    />
                    <div className="pointer-events-none absolute inset-0 bg-linear-to-b from-surface-900/5 from-50% to-surface-900 smMin:hidden" />
                </div>
                <H3 className="absolute inset-x-0 bottom-0 m-0 p-xs text-text-inverse smMin:static smMin:mt-sm smMin:mb-xs smMin:p-0 smMin:text-text-primary">
                    {title}
                </H3>
            </div>
            <span className="hidden items-center gap-2xs text-link-primary smMin:flex">
                <span className="group-hover:underline">{formatMessage(['curatedCollections', 'explore'])}</span>
                <ArrowRight size="sm" />
            </span>
        </RouteLink>
    );
};
